module.exports = __webpack_public_path__ + "img/payoff@3x.ebfe74ad.png";